import { cn } from '@/lib/cn';

type LogoVariant = 'color' | 'white' | 'icon';

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  alt?: string;
}

// Full-color transparent source (multi-format export provided by the brand).
const FULL_COLOR_SOURCE =
  'https://storage.helloreaddy.io/project_files/6b2ebeee-efdf-48ee-aa30-6a5f7ee4a4cd/48375883-670f-4321-a697-1ed9f9f44158_compressed_LaundryBox-icon-1024.webp';

const SOURCES: Record<LogoVariant, string> = {
  color: FULL_COLOR_SOURCE,
  // The white logo reuses the transparent full-color mark and is turned pure
  // white through a filter, so it stays transparent on dark surfaces.
  white: FULL_COLOR_SOURCE,
  icon: FULL_COLOR_SOURCE,
};

export default function Logo({ variant = 'color', className, alt = 'LaundryBox', }: LogoProps) {
  return (
    <img
      src={SOURCES[variant]}
      alt={alt}
      className={cn(
        'h-full w-auto object-contain',
        variant === 'white' && 'brightness-0 invert',
        className,
      )}
    />
  );
}